'use client';

import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Box from '@mui/material/Box';
import React from 'react';

export const ViewDocumentButton = () => (
	<Box
		style={{
			cursor: 'pointer',
			height: '100%',
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		}}
	>
		<InsertDriveFileIcon />
	</Box>
);
